export default "__VITE_ASSET__mbQaIwRO__"